import Vue from 'vue'

// Глобальное реактивное состояние для уведомлений (Vue 2 способ)
const notificationState = Vue.observable({
  notifications: []
})

class NotificationService {
  constructor() {
    this.nextId = 1
  }

  /**
   * Создает новое уведомление
   * @param {string} message - текст сообщения
   * @param {string} type - тип уведомления (success, error, warning, info)
   * @param {number} duration - время отображения в миллисекундах (0 = не скрывать автоматически)
   * @param {boolean} dismissible - можно ли закрыть уведомление вручную
   * @returns {number} ID созданного уведомления
   */
  show(message, type = 'info', duration = 5000, dismissible = true) {
    const notification = {
      id: this.nextId++,
      message,
      type,
      duration,
      dismissible,
      timestamp: Date.now()
    }

    console.log('Adding notification:', notification)
    console.log('Current notifications count:', notificationState.notifications.length)
    
    notificationState.notifications.push(notification)
    
    console.log('After push notifications count:', notificationState.notifications.length)

    // Автоматическое скрытие уведомления
    if (duration > 0) {
      setTimeout(() => {
        this.hide(notification.id)
      }, duration)
    }

    return notification.id
  }

  /**
   * Скрывает уведомление по ID
   * @param {number} id - ID уведомления
   */
  hide(id) {
    const index = notificationState.notifications.findIndex(n => n.id === id)
    if (index !== -1) {
      notificationState.notifications.splice(index, 1)
    }
  }

  /**
   * Очищает все уведомления
   */
  clear() {
    notificationState.notifications.splice(0)
  }

  /**
   * Показывает уведомление об успехе
   * @param {string} message - текст сообщения
   * @param {number} duration - время отображения
   */
  success(message, duration = 4000) {
    return this.show(message, 'success', duration)
  }

  /**
   * Показывает уведомление об ошибке
   * @param {string} message - текст сообщения
   * @param {number} duration - время отображения (0 = не скрывать автоматически)
   */
  error(message, duration = 0) {
    return this.show(message, 'error', duration)
  }

  /**
   * Показывает предупреждение
   * @param {string} message - текст сообщения
   * @param {number} duration - время отображения
   */
  warning(message, duration = 6000) {
    return this.show(message, 'warning', duration)
  }

  /**
   * Показывает информационное сообщение
   * @param {string} message - текст сообщения
   * @param {number} duration - время отображения
   */
  info(message, duration = 5000) {
    return this.show(message, 'info', duration)
  }

  /**
   * Получает все текущие уведомления
   * @returns {Array} массив уведомлений
   */
  getNotifications() {
    return notificationState.notifications
  }
}

// Создаем глобальный экземпляр сервиса
const notificationService = new NotificationService()

// Для отладки - добавляем в window
if (typeof window !== 'undefined') {
  window.testNotifications = () => {
    notificationService.success('Test success message')
    notificationService.error('Test error message')
    notificationService.warning('Test warning message')
    notificationService.info('Test info message')
  }
  window.notificationService = notificationService
}

export { notificationService, notificationState }
export default notificationService